
import { DisenioPaginas } from "../../layout";
import { useFacturasQuery } from "../../../hooks";
import { TablaFacturas } from "../../components/facturas";
import { BuscadorSoloValor, CargandoMedio } from "../../components";






export const ListadoFacturas = () => {


    const { data, isLoading, chagePage, page, termino, chageTermino } = useFacturasQuery();

    return (


        <DisenioPaginas titulo="Listado de Facturas" url={1} add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando Facturas..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar factura...' place='Buscar x numero proveedor...'
                />
                <TablaFacturas data={data || []} chagePage={chagePage} page={page} />
                </>
            }

        </DisenioPaginas>
    )
}
